import { Typography } from '@mui/material';
import { INode } from '../../Context/FormBuilderContext';

interface OutputWidgetProps {
  node: INode;
}

export function OutputWidget({ node }: OutputWidgetProps) {
  const styles = node?.data?.styles;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
      }}
    >
      {node?.data?.title && (
        <Typography
          variant="h6"
          style={{
            fontWeight: styles?.title?.isBold ? '700' : '400',
            fontStyle: styles?.title?.isItalic ? 'italic' : 'normal',
            textDecoration: styles?.title?.isUnderlined ? 'underline' : 'none',
            textAlign: styles?.title?.textAlign || 'left',
            fontFamily: styles?.title?.fontFamily || 'Roboto, sans-serif',
            fontSize: `${styles?.title?.fontSize || 16}px`,
            color: styles?.title?.color || '#1F2937',
            width: '100%',
            lineHeight: '150%',
            letterSpacing: '0.5px',
          }}
        >
          {node?.data?.title}
        </Typography>
      )}

      {node?.data?.subtitle && (
        <Typography
          style={{
            color: styles?.subtitle?.color || '#475467',
            fontFamily: styles?.subtitle?.fontFamily || 'Roboto, sans-serif',
            fontSize: `${(styles?.subtitle?.fontSize || 16) * 0.875}px`,
            fontWeight: styles?.subtitle?.isBold ? '600' : '400',
            fontStyle: styles?.subtitle?.isItalic ? 'italic' : 'normal',
            textDecoration: styles?.subtitle?.isUnderlined
              ? 'underline'
              : 'none',
            textAlign: styles?.subtitle?.textAlign || 'left',
            width: '100%',
            marginBottom: '8px',
            lineHeight: '150%',
            letterSpacing: '0.5px',
          }}
        >
          {node?.data?.subtitle}
        </Typography>
      )}

      <div
        style={{
          borderRadius: '6px',
          border: `1px solid #E4E7EC`,
          width: '100%',
          color: styles?.title?.color || '#babac0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
        }}
      />
    </div>
  );
}
